import React from 'react'
import { Icon } from "@material-ui/core";
import MetabaseLogo from './metabase-icon.svg'

export const MetabaseIcon = () => (
    React.createElement(Icon, null
        , React.createElement('img', { src: MetabaseLogo, alt: "", height: 25, width: 25,})
    )
)